import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  type GetFoodOrderCategoriesParams,
  type FoodOrderCategoriesResponse,
  getFoodOrderCategoriesFn,
} from './ahafood/get-category-fn';

export const useGetFoodOrderCategories = (
  params: GetFoodOrderCategoriesParams,
  opts?: Omit<
    UseQueryOptions<FoodOrderCategoriesResponse, Error>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<FoodOrderCategoriesResponse, Error>({
    queryKey: ['foodOrderCategories', params],
    queryFn: () => getFoodOrderCategoriesFn(params),
    ...opts,
  });
};
